import { call } from "../helpers/axiosInterceptor";

const getAllStudents = async (page: number = 1, limit: number = 10) => {
  const { data } = await call.get(`user`, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("refToken"),
    },
  });
  return data;
};

const createStudent = async (payload: any) => {
  const { data } = await call.post("user/create/admin", { ...payload },
    {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("refToken"),
      }
    },);

  return data;
};

const updateKid = async (payload: any) => {
  const { data } = await call.post("user/update", { ...payload },
    {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("refToken"),
      }
    },);
  return data;
};

const getKidsBysearch = async (query) => {
  const { data } = await call.get(`user/search/${query}`,
    {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("refToken"),
      }
    },);
  return data;
};

const deleteStudentProfile = async (studentId: string) => {
  try {
    const response = await call.delete(`/user/delete/${studentId}`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("refToken"),
      },
    });
  } catch (e: any) {
    console.error("Error deleting batch:", e.response?.data?.message || e.message);
  }
};

const bulkCreateStudents = async (students: any[]) => {
  const { data } = await call.post("user/bulk-create", students, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("refToken"),
    },
  });
  return data;
};

const getStudentDetails = async (studentId: string) => {
  try {
    const { data } = await call.get(`user/${studentId}`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("refToken"),
      }
    });
    return data;
  } catch (error) {
    console.error("Error fetching student details:", error);
    throw error;
  }
};

const toggleUserStatus = async (userId: string) => {
  try {
    const { data } = await call.put(`user/toggle-status/${userId}`, {}, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("refToken"),
      }
    });
    return data;
  } catch (error) {
    console.error("Error toggling user status:", error);
    throw error;
  }
};
export {
  bulkCreateStudents,
  getAllStudents,
  getStudentDetails,
  createStudent,
  updateKid,
  getKidsBysearch,
  deleteStudentProfile,
  toggleUserStatus  // Add the new function to exports
};